import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: ({ colors, spacing }) => css`
    padding: ${spacing.xs} 0;
    background-color: ${colors.background.white};
    img {
      max-width: 130px;
    }
  `,
  containerLogo: css`
    display: flex;
    justify-content: space-around;
    width: 100%;
  `,
})

export default useStyles
